import React from "react";
import ReactToExcel from "react-html-table-to-excel";
import StepTitle from "../universe_lite/StepTitle";
import UploadFileButton from "../../../common/buttons/uploadFileButton";

import "./buttonGroup.styles.scss";

const ButtonGroup = (props) => {
  const {
    upload,
    DisplayReset,
    resetHandler,
    filterVisible,
    filterHandler,
  } = props;

  return (
    <div className="security-group-button-holder">
      <div className="heading">
        <StepTitle />
      </div>

      <div className="btn-holder">
        <button className="btn margin-r" onClick={filterHandler}>
          <i className="fa fa-filter" /> FILTER Securities{" "}
          <i
            className={`fa fa-angle-double-down ${
              filterVisible
                ? "fa fa-angle-double-down rotateAngle Angledown"
                : "fa fa-angle-double-down rotateAngle"
            }`}
          />
        </button>
        <ReactToExcel
          table="universe_table_download"
          filename="security"
          sheet="security"
          buttonText=" 📄 Download securities"
          className="btn margin-r"
        />
        <div style={{ display: "flex" }}>
          <UploadFileButton
            text="Upload securities"
            icon="fa-upload"
            iconRight={false}
            eventHandler={upload}
            id="upload_scenario_file"
          />
          {DisplayReset ? (
            <button
              className={
                DisplayReset
                  ? "btn create_reset fadeIn"
                  : "btn create_reset fadeOut"
              }
              onClick={resetHandler}
            >
              <i className="fa fa-undo"></i> Reset
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ButtonGroup;



// WEBPACK FOOTER //
// ./src/components/pages/Create/universe/buttonGroup.jsx